<template>
  <div class="certificate-popup-component">
    <ym-popup class="certificate-popup-component-popup"
              v-model="visible"
              get-container="body"
    >
      <div class="certificate-popup-container">
        <ym-icon class="certificate-popup-icon-close"
                 name="round-close"
                 @click.native="handleClose"
        />
        <div class="certificate-popup-desc">你已顺利学完</div>
        <div v-if="title.length !== 0"
             class="certificate-popup-product-title"
        >
          {{ title }}
        </div>
      </div>
      <div class="certificate-popup-btn-container">
        <ym-button class="certificate-popup-btn"
                   type="primary"
                   size="large"
                   round
                   @click="handleClick"
        >领取证书
        </ym-button>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup, Button } from '@ymba/ym-ui';

  export default {
    name: 'CertificatePopup',
    components: {
      'ym-popup': Popup,
      'ym-button': Button,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: Boolean,
      id: {
        type: Number,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
    },
    methods: {
      handleClick() {
        const { id } = this;
        const route = { name: 'CertificateDetail', params: { id } };
        this.$router.push(route);
        this.visible = false;
      },
      handleClose() {
        this.visible = false;
      },
    },
    created() {
      this.visible = this.show;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .certificate-popup {
    &-component-popup {
      background: none;
    }
    &-container {
      position: relative;
      text-align: center;
      font-size: @font-size-medium;
      padding: 392px @size-large @size-large;
      width: 600px;
      height: 603px;
      background: url("~@/assets/img/certificate/certificate_popup_bg.png") no-repeat center center;
      background-size: contain;
      box-sizing: border-box;
    }
    &-icon-close {
      position: absolute;
      top: -4px;
      right: @size-small;
      font-size: 50px;
      color: @color-white;
    }
    &-desc {
      line-height: 1;
      margin-bottom: @size-small;
    }
    &-product-title {
      font-weight: @font-weight-primary;
    }
    &-btn-container {
      padding: 0 @size-large;
    }
  }
</style>
